import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file\"><path d=\"M131.3 376.7H64.2v483.2c0 37.1 30.3 67.3 67.1 67.3H892c37 0 67.1-30.3 67.1-67.3V376.7H131.3z m768.3-164.1H798.2c-2 0-4 0.1-6.1 0.3h-306v-54.6c0-33.2-26.9-60.1-60-60.1H124.5c-33.2 0-60 27-60 60.1v174h894.9V272.4c-0.1-32.9-27-59.8-59.8-59.8z\" fill=\"\" p-id=\"29380\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol